'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const Pricing = renderWithRef('Pricing', null, (n, o)=>{
    let { children: t } = n;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: o,
        classNames: new Set([
            'swan-pricing'
        ]),
        props: n,
        children: t
    });
});

export { Pricing };
